export default function () {
  return {
    faqs: undefined,
  };
}
